var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 91,
    viewBox: "0 0 69 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.975547 77.6587V66.2603H15.7416V73.1253L20.6636 78.0473H48.9005L54.0816 72.8662V56.1572L49.0301 51.1057H14.5759L1.2346 37.8939V13.6724L14.5759 0.33111H54.4702L67.8115 13.6724V25.2003H53.0454V18.2058L47.9938 13.2838H21.0522L16.0007 18.2058V33.231L21.0522 38.153H55.5064L68.8477 51.4943V77.3997L55.2474 91H14.3168L0.975547 77.6587Z",
    fill: "#A78FEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.b983a4743579bb0738dff8f7855a95d5.svg";
export { ForwardRef as ReactComponent };